import {
	Add as AddIcon,
	Check as CheckIcon,
	Edit as EditIcon,
	ChevronRight as RightIcon,
	DeleteRounded as RemoveIcon,
} from '@material-ui/icons';
import {
	type ButtonProps,
	Button as MuiButton,
	type Theme,
	makeStyles,
} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
	button: {
		fontSize: 14,
		fontWeight: 500,
	},
	hideLabel: {
		'& .MuiButton-startIcon': {
			margin: 0,
		},
	},
	secondary: {
		'&:hover': {
			background: theme.palette.secondary.main,
			boxShadow: 'none',
		},
		background: theme.palette.secondary.main,
		color: '#fff',
	},
	small: {
		fontSize: 11,
		fontWeight: 500,
	},
	white: {
		'& svg': {
			fill: theme.palette.primary.main,
		},
		'&:hover': {
			background: '#f2f2f2',
			boxShadow: 'none',
		},
		background: '#fff',
		border: '1px solid #CFD8E3',
		color: theme.palette.text.primary,
	},
}));

interface Props {
	backgroundColor?: 'white' | 'secondary';
	small?: boolean;
	actionType?: 'add' | 'save' | 'edit' | 'next' | 'remove';
	hideLabelOnMobile?: boolean;
}

export function Button({
	actionType,
	backgroundColor,
	children,
	hideLabelOnMobile,
	small,
	...rest
}: Props & ButtonProps) {
	const classes = useStyles();

	function getIcon() {
		switch (actionType) {
			case 'add':
				return <AddIcon />;

			case 'save':
				return <CheckIcon />;

			case 'edit':
				return <EditIcon />;

			case 'next':
				return <RightIcon />;

			case 'remove':
				return <RemoveIcon />;

			default:
				return <div />;
		}
	}

	return (
		<MuiButton
			className={clsx({
				[classes.button]: !small,
				[classes.small]: small,
				[classes.white]: backgroundColor === 'white',
				[classes.secondary]: backgroundColor === 'secondary',
				[classes.hideLabel]:
					hideLabelOnMobile && window.innerWidth <= 960,
			})}
			color={'secondary'}
			disableElevation
			size={small ? 'small' : 'medium'}
			startIcon={actionType && getIcon()}
			variant={'contained'}
			{...rest}
		>
			{hideLabelOnMobile && window.innerWidth <= 960 ? '' : children}
		</MuiButton>
	);
}
